import { render, staticRenderFns } from "./userDataForm.vue?vue&type=template&id=ab016b3a&"
import script from "./userDataForm.vue?vue&type=script&lang=js&"
export * from "./userDataForm.vue?vue&type=script&lang=js&"
import style0 from "./userDataForm.vue?vue&type=style&index=0&id=ab016b3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports